import React, { Component } from 'react';

import EnterpriseMaintenanceUsers       from './EnterpriseMaintenanceUsers';
import EnterpriseMaintenanceEnterprises from './EnterpriseMaintenanceEnterprises';

class EnterpriseMaintenance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDisabled: false,
    }
    this.toggleDisabled = this.toggleDisabled.bind(this);
  }

  toggleDisabled() {
    this.setState({
      showDisabled: !this.state.showDisabled,
    });
  }

  render() {
    if (this.props.enterpriseUsers.length) {
      return  <EnterpriseMaintenanceUsers
                context={this.props.context}
                deleteUser={this.props.deleteUser}
                enterpriseDetail={this.props.enterpriseDetail}
                enterpriseGUID={this.props.enterpriseGUID}
                enterpriseUsers={this.props.enterpriseUsers}
                enterprises={this.props.enterprises}
                getEnterpriseRoles={this.props.getEnterpriseRoles}
                getEnterpriseUsers={this.props.getEnterpriseUsers}
                getUserInfo={this.props.getUserInfo}
                impersonatedUsers={this.props.impersonatedUsers}
                inviteUser={this.props.inviteUser}
                licenseID={this.props.licenseID}
                location={this.props.location}
                method={this.props.method}
                permissions={this.props.permissions}
                primaryGUID={this.props.primaryGUID}
                secondaryGUID={this.props.secondaryGUID}
                setupGlobalImpersonation={this.props.setupGlobalImpersonation}
                showMessageBox={this.props.showMessageBox}
                stageUserForDelete={this.props.stageUserForDelete}
                submethod={this.props.submethod}
                updateUser={this.props.updateUser}
                userInfo={this.props.userInfo}
                unstageUsersForDelete={this.props.unstageUsersForDelete}
                setQuestion={this.props.setQuestion}
                history={this.props.history}
              />
    }
    return  <EnterpriseMaintenanceEnterprises
              addEnterprise={this.props.addEnterprise}
              clearEnterpriseInfo={this.props.clearEnterpriseInfo}
              context={this.props.context}
              deleteEnterpriseDomain={this.props.deleteEnterpriseDomain}
              enterpriseDetail={this.props.enterpriseDetail}
              enterpriseGUID={this.props.enterpriseGUID}
              enterprises={this.props.enterprises}
              getDefaultPasswordConfiguration={this.props.getDefaultPasswordConfiguration}
              getEnterpriseInfo={this.props.getEnterpriseInfo}
              getEnterpriseRoles={this.props.getEnterpriseRoles}
              isLoading={this.props.isLoading}
              licenseID={this.props.licenseID}
              location={this.props.location}
              method={this.props.method}
              primaryGUID={this.props.primaryGUID}
              secondaryGUID={this.props.secondaryGUID}
              showMessageBox={this.props.showMessageBox}
              submethod={this.props.submethod}
              thereWasAnError={this.props.thereWasAnError}
              updateEnterpriseDomains={this.props.updateEnterpriseDomains}
              updateEnterpriseInfo={this.props.updateEnterpriseInfo}
              utilities={this.props.utilities}
              setQuestion={this.props.setQuestion}
              history={this.props.history}
            />
  }
}

export default EnterpriseMaintenance;



// WEBPACK FOOTER //
// ./src/components/Admin/EnterpriseMaintenance.js